module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm-1"
  }, [_vm._v("‘As an artist, you should aspire to")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("capture the atmosphere, mood, and")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("that vital impression of depth and")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("distance in your work. Aim to make the")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("viewer feel involved in the scene, as")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("though they could walk into it.’")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geoff Kersey")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f001-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6857633b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Author.vue
// module id = 60
// module chunks = 0